<template>
  <div class="mx-auto col-md-6 mt-5">

    <b-card header="Lets sign you in real quick" header-tag="header">
        <b-form @submit="login" class="col">
            <b-form-input
                id="input-1"
                v-model="form.email"
                type="email"
                required
                placeholder="Enter your email"
            ></b-form-input>
            <br>
            <b-input 
                type="password" 
                id="text-password"
                v-model="form.password"
                placeholder="Enter your password"
            >
            </b-input>
            <br>
            <b-button type="submit" variant="primary">Login</b-button>

        </b-form>
    </b-card>
  </div>
</template>

<script>
export default {
    data () {
        return {
            form: {
                email: "abc@example.com",
                password: "secret"
            }
        }
    },
    methods: {
        login: function (e) {
            e.preventDefault()
            this.$store.dispatch('AUTH_REQUEST', this.form).then(() => {
                this.$router.push('/')
            }).catch((error) => {
                console.log(error)
            })
        }
    }
}
</script>